import { $Color, $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'LearningStage';

export const LearningStage = {
  GetIt: tagEnum($, 1),
  GotIt: tagEnum($, 2),
  UseIt: tagEnum($, 3),
  OwnIt: tagEnum($, 4),
} as const;

export type LearningStage = TaggedEnumUnion<typeof LearningStage>;

const LearningStages = {
  [$tag]: $,
  [LearningStage.GetIt]: {
    value: LearningStage.GetIt,
    slug: 'get-it',
    label: 'Get It',
    instructional: 'Acquisition',
    color: $Color.from('#5599ee'),
  },
  [LearningStage.GotIt]: {
    value: LearningStage.GotIt,
    slug: 'got-it',
    label: 'Got It',
    instructional: 'Fluency',
    color: $Color.from('#44cc66'),
  },
  [LearningStage.UseIt]: {
    value: LearningStage.UseIt,
    slug: 'use-it',
    label: 'Use It',
    instructional: 'Generalization',
    color: $Color.from('#ff9984'),
  },
  [LearningStage.OwnIt]: {
    value: LearningStage.OwnIt,
    slug: 'own-it',
    label: 'Own It',
    instructional: 'Adaptation',
    color: $Color.from('#cc66cc'),
  },
} as const;

export const $LearningStage = buildStaticContext(LearningStages);
